import React from 'react';
import PropTypes from 'prop-types';
import DropdownField from 'components/forms/DropdownField';
import FormField from './../FormField';
import DateField from './../DateField';
import TimeField from './../TimeField';
import SwitchButtonField from './../SwitchButtonField';
import EventLengthCalculator from './../EventLengthCalculator';
import { formValues } from 'redux-form';
import some from 'lodash/some';
import allCategories from 'lib/categoriesMapper';

const DoorTimeFieldset = formValues({ category_id:'category_id', sub_categories: 'sub_categories' })((props) => {
  if (props.category_id === undefined) { return null; }
  if (!some(
    allCategories(props.category_id, props.sub_categories, props.categories),
    (cat) => cat.extra_event_times)
  ) {
    return null;
  }

  return (
    <div className="row">
      <div className="col">
        <FormField
          label="Door Time"
          name="door_time"
          component={TimeField}
          error={props.formErrors.get('door_time')}
          onFocusTip="Type your time in any format"
          type="text"
        />
      </div>
      <div className="col">
        <FormField
          label="Last Entry Time"
          name="last_entry_time"
          component={TimeField}
          error={props.formErrors.get('last_entry_time')}
          onFocusTip="Type your time in any format"
          type="text"
        />
      </div>
    </div>
  );
});

const DateTimeFieldset = formValues('is_multiday', 'start_date', 'venue', 'online')
(({ is_multiday, start_date, formErrors, categories, timeZones, venue, online }) => {
  const end_date_min = start_date ? new Date(start_date) : new Date();
  const showTimeZone = online && !(venue && venue.country);

  return <div className="DateTimeFieldset">
    <div className="row">
      <div className={is_multiday ? 'col-6' : 'col-12 col-lg-6'}>
        <FormField
          label="Start Date"
          name="start_date"
          error={formErrors.get('start_date')}
          component={DateField}
          inputProps={{ culture: 'en', textField: 'name', date: true, time: false }}
          type="text"
          required
          infoUrl="https://support.evvnt.com/hc/en-us/articles/217192357-Basics-Adding-the-date-and-time7"
        />
      </div>
      <div className={is_multiday ? 'col-6' : 'col-6 col-lg-3'}>
        <FormField
          label="Start Time"
          name="start_time"
          error={formErrors.get('start_time')}
          component={TimeField}
          onFocusTip="Type your time in any format"
          type="text"
          placeholder="9am"
          required
        />
      </div>
      {is_multiday && <div className="col-6">
        <FormField
          label="End Date"
          name="end_date"
          error={formErrors.get('end_date')}
          component={DateField}
          inputProps={{ culture: 'en', textField: 'name', date: true, time: false, min: end_date_min }}
          type="text"
          required
        />
      </div>}
      <div className={is_multiday ? 'col-6' : 'col-6 col-lg-3'}>
        <FormField
          label="End Time"
          name="end_time"
          error={formErrors.get('end_time')}
          component={TimeField}
          onFocusTip="Type your time in any format"
          type="text"
          placeholder="5pm"
          required
        />
      </div>
      {showTimeZone && <div className="col-12">
        <FormField
          label="Time Zone"
          error={formErrors.get('time_zone')}
          name="time_zone"
          component={DropdownField}
          inputProps={{ valueField: 'value', textField: 'name' }}
          data={timeZones}
          type="text"
          className="form-control"
          placeholder="Select a Time Zone"
          required
        />
      </div>}
      <div className="col-6">
        <FormField
          name="is_multiday"
          component={SwitchButtonField}
          inputProps={{ title: is_multiday ? '- Single-day Event?' : '+ Multi-day Event?' }}
        />
        <div className="mb-3 font-italic">
          To add extra dates to your event, post the first date and additional dates from your events dashboard,
          <a href="https://support.evvnt.com/hc/en-us/articles/360018712599-How-do-I-post-a-recurring-event-"> more info here.</a>
        </div>
      </div>
      {!is_multiday && <div className="col-6 text-right">
        <EventLengthCalculator/>
      </div>}
    </div>
    <DoorTimeFieldset categories={categories} formErrors={formErrors}/>
  </div>;
});

DateTimeFieldset.propTypes = {
  formErrors: PropTypes.object,
  is_multiday: PropTypes.bool,
  categories: PropTypes.array.isRequired,
};

export default DateTimeFieldset;



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/components/forms/fieldsets/DateTimeFieldset.jsx